export const sellSpiceAmounts = [
  { spice: 2, solaris: 6 },
  { spice: 3, solaris: 8 },
  { spice: 4, solaris: 10 },
  { spice: 5, solaris: 12 },
];
